/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import { useEffect } from 'react';

export const addDomListener = (type, fn) => {
    // eslint-disable-next-line no-undef
    window.addEventListener(type, fn, false);
    // eslint-disable-next-line no-undef
    return () => window.removeEventListener(type, fn);
};

export const useDomListener = (type, fn) => useEffect(() => addDomListener(type, fn), [ fn, type ]);

export const scrollToError = (selector) => {
    // eslint-disable-next-line no-undef
    const element = window.document.querySelector(selector);

    element.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
    });
};
